import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { Copy, Link, Stack } from '@grubhubprod/gh-cookbook-react';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { getYesAndNoOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { CustomLabelWithTooltip } from 'src/components/common/CustomLabelWithTooltip/CustomLabelWithTooltip';
import { buildCAUIPath, CAUIPage } from 'src/constants/urls';

export interface CompanyOrderPolicySegmentedControlProps {
  name: string;
  id: string;
  corpId: string;
}

export function CompanyOrderPolicySegmentedControl({
  name,
  id,
  corpId,
}: CompanyOrderPolicySegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      id={id}
      control={control}
      width="100%"
      label={
        <CustomLabelWithTooltip
          labelText="Company ordering policy"
          tooltipInfo={
            <>
              <Stack y="md">
                <Copy variant="body" color="invertedPrimaryText">
                  To review your company's ordering policy, go to "Company
                  details" or reach out to Client Relations.
                </Copy>
              </Stack>
              <Link
                style={{
                  color: 'white',
                  textDecoration: 'underline',
                }}
                href={buildCAUIPath(CAUIPage.ORDERING_POLICY, { corpId })}
              >
                View company details
              </Link>
            </>
          }
        />
      }
      name={name}
      defaultValue="No"
      options={getYesAndNoOptions(id)}
    />
  );
}
